module.exports = __webpack_public_path__ + "img/scene4.3f15372f.png";